import {Component, OnInit} from '@angular/core';
import {CheckboxModule} from "primeng/checkbox";
import {DateTextPipe} from "../../pips/date-text.pipe";
import {NgIf} from "@angular/common";
import {NumberTextPipe} from "../../pips/number-text.pipe";
import {SharedModule} from "primeng/api";
import {Table, TableModule} from "primeng/table";
import {Contact} from "../../dto/Contact";
import {AdminTemplateComponent} from "../admin-template/admin-template.component";
import {DialogModule} from "primeng/dialog";
import {ImageManagerComponent} from "../componnts/image-manager/image-manager.component";
import {PaginatorModule} from "primeng/paginator";
import {Pages} from "../../dto/Pages";
import {TabViewModule} from "primeng/tabview";
import {Setting} from "../../dto/Setting";

@Component({
    selector: 'app-admin-contact-page',
    standalone: true,
    imports: [
        CheckboxModule,
        DateTextPipe,
        NgIf,
        NumberTextPipe,
        SharedModule,
        TableModule,
        DialogModule,
        ImageManagerComponent,
        PaginatorModule,
        TabViewModule
    ],
    templateUrl: './admin-contact-page.component.html',
    styleUrl: './admin-contact-page.component.css'
})
export class AdminContactPageComponent extends AdminTemplateComponent implements OnInit {


    listContact: Array<Contact> = new Array<Contact>();
    totalContact: number = 0;
    query: string = '';
    displayDetContact: boolean = false;
    selectedContact: Contact = new Contact();

    ngOnInit() {
        this.loadMainPage();
    }

    loadListContact(table: Table) {
        this.global.progressBar = true;
        var observable = this.restBack.doGet("lnd/contact/get_contact_list?" +
            "page=" + (table != null ? table.first / 10 : 0) +
            "&nrpp=" + (table != null && table.rows ? table.rows : 10) +
            "&query=" + this.query
        );
        observable.subscribe({
            next: (res: string) => {
                if (res["status"] == 200) {
                    this.listContact = res["entity"];
                    this.totalContact = res["total"];

                }
                if (res["status"] == 401) {
                    this.gotoLogin();
                }
                return res;
            },
            error: (e) => {
                this.messageService.clear();
                this.messageService.add({
                        severity: 'error',
                        summary: $localize`:@@Error:Error`,
                        detail: $localize`:@@Server Timout Det:Server Timout Det`
                    }
                );
            },
            complete: () => {
                this.global.progressBar = false;
            }
        });
    }

    deleteContact(contact: Contact, dt: Table) {
        this.confirmationService.confirm({
            message: $localize`:@@Are you sure to delete?:Are you sure to delete?`,
            header: $localize`:@@Delete:Delete`,
            acceptLabel: $localize`:@@Yes:Yes`,
            rejectLabel: $localize`:@@No:No`,
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.global.progressBar = true;
                var observable = this.restBack.doGet("lnd/contact/delete_contact?" +
                    "id=" + contact.id);
                observable.subscribe({
                    next: (res: string) => {
                        if (res["status"] == 200) {
                            this.messageService.clear();
                            this.messageService.add({
                                    severity: 'info',
                                    summary: $localize`:@@Delete:Delete`,
                                    detail: $localize`:@@Delete Success:Delete Success`
                                }
                            );
                            this.loadListContact(dt);
                        }
                        if (res["status"] == 401) {
                            this.gotoLogin();
                        }
                        return res;
                    },
                    error: (e) => {
                        this.messageService.clear();
                        this.messageService.add({
                                severity: 'error',
                                summary: $localize`:@@Error:Error`,
                                detail: $localize`:@@Server Timout Det:Server Timout Det`
                            }
                        );
                    },
                    complete: () => {
                        this.global.progressBar = false;
                    }
                });
            }
        });

    }

    showDetContact(contact: Contact) {
        this.selectedContact = contact;
        this.displayDetContact = true;
        this.saveRead();

    }
    saveRead() {
        let params = {id:this.selectedContact.id};
        let body = {};
        this.global.progressBar = true;
        var observable = this.restBack.doPost("lnd/contact/read_contact", body, params);
        observable.then((res: string) => {
                if (res["status"] == 200) {
                    let o = res["entity"];
                    // this.loadIndexData(null);

                    // this.messageService.clear();
                    // this.messageService.add({
                    //     severity: 'info',
                    //     summary: $localize`:@@Save_Success:Save Success`,
                    //     detail: $localize`:@@Save_Success_Det:Save_Success_Det`
                    // });


                } else if (res["status"] == 400) {

                } else if (res["status"] == 401) {

                }
                return res;
            },
            error => {
                this.messageService.clear();
                this.messageService.add({
                        severity: 'error',
                        summary: $localize`:@@Error:Error`,
                        detail: $localize`:@@Server Timout Det:Server Timout Det`
                    }
                );
            }).finally(() => {
            this.global.progressBar = false;


        });
    }

    //..............................................
    selectedSetting: Setting = new Setting();
    contactSetting = {
        desc: '',
        phone: '',
        address: '',
        email: '',
        formDesc: ''
    }

    saveContactSetting() {
        let params = {};
        this.selectedSetting.data = JSON.stringify(this.contactSetting);
        this.selectedSetting.type = "CONTACT_US";
        let body = this.selectedSetting;
        this.global.progressBar = true;
        var observable = this.restBack.doPost("lnd/setting/save_setting", body, params);
        observable.then((res: string) => {
                if (res["status"] == 200) {
                    let o = res["entity"];
                    // this.loadIndexData(null);

                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'info',
                        summary: $localize`:@@Save_Success:Save Success`,
                        detail: $localize`:@@Save_Success_Det:Save_Success_Det`
                    });


                } else if (res["status"] == 400) {

                } else if (res["status"] == 401) {

                }
                return res;
            },
            error => {
                this.messageService.clear();
                this.messageService.add({
                        severity: 'error',
                        summary: $localize`:@@Error:Error`,
                        detail: $localize`:@@Server Timout Det:Server Timout Det`
                    }
                );
            }).finally(() => {
            this.global.progressBar = false;


        });
    }


    loadMainPage() {
        this.global.progressBar = true;
        var observable = this.restBack.doGet("lnd/setting/get_setting?" +
            "&type=CONTACT_US");
        observable.subscribe({
            next: (res: string) => {
                if (res["status"] == 200) {
                    this.selectedSetting = res["entity"];
                    if (this.selectedSetting.data != null) {
                        this.contactSetting = JSON.parse(this.selectedSetting.data);
                    } else {
                        this.contactSetting = {
                            desc: '',
                            phone: '',
                            address: '',
                            email: '',
                            formDesc: ''
                        }
                    }

                }
                if (res["status"] == 401) {
                    this.gotoLogin();
                }
                return res;
            },
            error: (e) => {
                this.messageService.clear();
                this.messageService.add({
                        severity: 'error',
                        summary: $localize`:@@Error:Error`,
                        detail: $localize`:@@Server Timout Det:Server Timout Det`
                    }
                );
            },
            complete: () => {
                this.global.progressBar = false;
            }
        });
    }

}
